module.exports = __webpack_public_path__ + "img/Support-skill-215.ebc3bca9.png";